import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useRouteMatch, Route, Switch, useParams, useHistory, useLocation } from "react-router-dom";

import cx from 'classnames';
import _ from 'lodash';

import {
  Row,
  Col,
  ListGroup,
  Button
} from "react-bootstrap";
import { useIntercom } from 'react-use-intercom';

import { IntegrationView } from "./integrationView";
import UserManagementView from '../usermanagement'
import { HubSpotIntegration } from "./hubspot";
import { MarketoIntegration } from "./marketo";
import { SalesforceIntegration } from "./salesforce";

import styles from './integration.module.scss';

import userRoleService from 'services/userRoles.service';
import { PardotIntegration } from "./pardot";
import { fetchIntegrations } from "actions/integrations/integrations";
import cleverStoryLogo from "../../../assets/images/logo/logo-cs.svg";
import workspaceSpaceman from "../../../assets/images/workspaceSpaceman.png"
import workspaceCloud from "../../../assets/images/workspaceCloud.png"
import FormsView from "../forms";
import FormConfigurations from "../forms/formConfigurations/index";
import { ZohoIntegration } from "./zoho";

const INTERCOM_ID = process.env.REACT_APP_CLEVERSTORY_INTERCOM_ID;

export default function IntegrationSettings() {
  const dispatch = useDispatch();
  const location = useLocation();

  const activeWorspace = useSelector(state => _.get(state, `workspaces.workspace.item`));
  const { boot, show } = useIntercom();
  const user = useSelector((state) => _.get(state, "users.me"));
  const workspace = useSelector(state => _.get(state, 'workspaces.workspace.item', {}));
  const [formManagementView, setFormManagementView] = useState(false);

  var paths = location.pathname.split('/');
  paths.splice(0, 3);
  var currentPath = paths.join('/');
  var permission = userRoleService.requirePermission(currentPath, workspace);
  const isFormManageView = useSelector(state => _.get(state, `forms.formManageView`, false));

  const initializeIntercom = () => {

    boot({
      appID: INTERCOM_ID,
      name: `${user.firstName} || '' ${user.lastName} || ''`,
      userId: `${user.email}`,
      email: `${user.email}`,
      hideDefaultLauncher: true,
    })
  }

  useEffect(() => {
    if (user) {
      initializeIntercom();
    }
  }, [user]);

  let { path, url } = useRouteMatch();

  useEffect(() => {
    dispatch(fetchIntegrations());
  }, [])

  const handleFormManagementView = () => {
    setFormManagementView(false);
  }

  useEffect(() => {
    if (isFormManageView) {
      setFormManagementView(true);
    }
  }, [isFormManageView])

  return (
    <div className={styles.content}>
      <Row className={styles.integrationsWrapper}>
        {!formManagementView && <Col className={styles.settingsMenu} md={3}>
          <header className={styles.header}>
            <span className={styles.workspaceTitle}>{_.get(activeWorspace, 'name')}</span>
            <h1 className={styles.secondaryTitle}>Settings</h1>
            <span className={styles.subText}>Get all your things in place,<br></br>As you prepare for outer space</span>
          </header>

          <ListGroup variant="flush" className={styles.settingsListGroup}>
            {userRoleService.canManageUsers() &&
              <ListGroup.Item as={NavLink} activeClassName={styles.active} to={`${url}/user-management`}>
                User Management
              </ListGroup.Item>
            }
            <ListGroup.Item as={NavLink} activeClassName={styles.active} to={`${url}/integration`}>
              Integration
            </ListGroup.Item>

            <ListGroup.Item as={NavLink} activeClassName={styles.active} to={`${url}/forms`}>
              Form Management
            </ListGroup.Item>

            <ListGroup.Item className={styles.helpButton} onClick={show} activeClassName={cx(styles.active)}>
              Help
            </ListGroup.Item>
          </ListGroup>
        </Col>}
        <Col className={cx(styles.settingsContent, { [styles.fullView]: formManagementView })} md={formManagementView ? 12 : 9}>
          <Switch>
            <Route>
              {permission &&
                <>
                  <Route path={`${path}/user-management`}>
                    <UserManagementView />
                  </Route>

                  <Route path={`${path}/integration`} exact>
                    <IntegrationView />
                  </Route>

                  <Route path={`${path}/integration/hubspot`}>
                    <HubSpotIntegration />
                  </Route>

                  <Route path={`${path}/integration/marketo`}>
                    <MarketoIntegration />
                  </Route>

                  <Route path={`${path}/integration/pardot`}>
                    <PardotIntegration />
                  </Route>

                  <Route path={`${path}/integration/salesforce`}>
                    <SalesforceIntegration />
                  </Route>

                  <Route path={`${path}/integration/zoho`}>
                    <ZohoIntegration />
                  </Route>

                  <Route path={`${path}/forms`} exact>
                    <FormsView formManagementView={handleFormManagementView} />
                  </Route>

                  <Route path={`${path}/forms/:formId`}>
                    <FormConfigurations />
                  </Route>
                </>}
              {!permission &&
                <AccessDenied />
              }
            </Route>
          </Switch>
        </Col>
      </Row>
    </div>
  )
}

function AccessDenied() {

  return (
    <div className={styles.errorMessageContainer}>
      <div className={styles.errorMessageWrapper}>
        <img src={workspaceSpaceman} className={styles.workspaceSpaceman} />
        <img src={workspaceCloud} className={styles.workspaceCloud} />
        <div className={styles.errorMessageContent}>
          <img src={cleverStoryLogo} className={styles.errorMessageLogo} />
          <div className={styles.errorMessageTitle}>
            <span>Seat</span>
            <span>not found</span>
          </div>
          <div className={styles.errorMessageSubText}>
            <span>Looks like there’s no seat on this workspace with your name on it. Please contact your admin to get access.</span>
            <Button href="/login" className={styles.logoutBtn}>Logout</Button>
          </div>
        </div>
      </div>
    </div>
  )
}